// extracted by mini-css-extract-plugin
export default {"main_wrapper":"OnbordingLayout_main_wrapper__AmdU+","carousel-root":"OnbordingLayout_carousel-root__NbM5m"};